import styled from 'styled-components';

import { Text } from '@sternum/web/components/Text';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const Tag = styled.div<{ $isSandbox?: boolean }>`
  display: flex;
  align-items: center;
  gap: 5px;
  text-transform: uppercase;
  border-radius: 3px;
  border: 1px solid ${ct({ Dark: Colors.DarkerMiddle, Light: Colors.DarkerMiddle })};
  color: ${ct({ Dark: Colors.White, Light: Colors.White })};
  padding: 4px 6px;
`;

export const TagForSandbox = styled(Tag)`
  border: 1px solid ${ct({ Dark: Colors.OrangeDarkest, Light: Colors.OrangeDarkest })};
`;

export const TagForTrial = styled(Tag)`
  border: 1px solid ${ct({ Dark: Colors.BlueDark, Light: Colors.BlueDark })};
`;

export const TextForTag = styled(Text)`
  font-size: 8px;
  font-weight: 500;
  line-height: 1;
`;
